import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { NotificationService } from '../notifications/notification.service';

export const notificationInterceptor: HttpInterceptorFn = (req, next) => {
  const notifications = inject(NotificationService);
  return next(req).pipe(
    tap((event) => {
      if (
        'headers' in event &&
        event.headers?.get('X-Notifications-Changed') === 'true'
      ) {
        notifications.refreshAfterMutation();
      }
    }),
  );
};
